export default (theme: Object) => ({
  breadcrumb: {
    color: theme.palette.neutrals.mainText,
    fontSize: '19px',
  },
});
